import { DayButton, DayButtonProps } from '@daypicker/react'
import { astraTwMerge, SizeOptions } from 'astra'

import { getDayButtonStyles } from './AstraDayPickerDayStyles'

type Props = DayButtonProps & {
    size: SizeOptions
}

const dayButtonLabelSizeStyles: Record<SizeOptions, string> = {
    small: 'size-7',
    medium: 'size-9',
    large: 'size-11',
}

export const AstraDayPickerDayButton = ({ children, className, modifiers, size, ...rest }: Props) => (
    <DayButton {...rest} modifiers={modifiers} className={className}>
        <span className={astraTwMerge('flex items-center justify-center rounded-full', dayButtonLabelSizeStyles[size], getDayButtonStyles(modifiers))}>
            {children}
        </span>
    </DayButton>
)
